import { ActivatedRouteSnapshot, Route } from '@angular/router';

/** routeConfig references down the primary outlet, root -> leaf. */
export function getRouteChain(root: ActivatedRouteSnapshot): (Route | null)[] {
  const chain: (Route | null)[] = [];
  for (let route: ActivatedRouteSnapshot | null = root; route != null; route = route.firstChild) {
    chain.push(route.routeConfig);
  }
  return chain;
}

/** Angular reuses a routed component exactly when every routeConfig from root to leaf is identical
 * (BaseRouteReuseStrategy.shouldReuseRoute), so equal chains mean the same page stays on screen. */
export function isSameRouteChain(a: (Route | null)[], b: (Route | null)[]): boolean {
  return a.length === b.length && a.every((cfg, ix) => cfg === b[ix]);
}
